import React from 'react';
import {FeedbacksData} from '../services/type';
import {MobileFeedbackList} from './mobile-feedback-list';
import {TextField, Typography, TableSortLabel, withStyles} from '@material-ui/core';
import {styles, Classes} from './styles';

interface MobileStatistic {
    data: FeedbacksData[];
    filterUser: (e: React.ChangeEvent<HTMLInputElement>) => void;
    filterAuthor: (e: React.ChangeEvent<HTMLInputElement>) => void;
    sortingRating: () => void;
    derection: 'asc' | 'desc';
    authorFilter: string;
    recipientFilter: string;
}

type IProps = Classes & MobileStatistic;

const MobileStatistic = (props: IProps) => {
    return (
        <>
            <div className={props.classes.wrapText}>
                <TextField
                    label="Author"
                    fullWidth={true}
                    value={props.authorFilter}
                    variant="outlined"
                    onChange={props.filterAuthor}
                />
            </div>
            <div className={props.classes.wrapText}>
                <TextField
                    label="Recipient"
                    variant="outlined"
                    value={props.recipientFilter}
                    fullWidth={true}
                    onChange={props.filterUser}
                />
            </div>
            <TableSortLabel
                classes={{root: props.classes.arrow, icon: props.classes.icon}}
                onClick={props.sortingRating}
                active={true}
                direction={!props.derection ? 'desc' : props.derection}
            />
            {props.data.length > 0 ? (
                props.data.map(data => <MobileFeedbackList key={data.feedbacks[0].feedbackId} feedbacks={data} />)
            ) : (
                <Typography color="primary" align="center" component="p">
                    Not Found
                </Typography>
            )}
        </>
    );
};

export default withStyles(styles)(React.memo(MobileStatistic));
